import React, { useEffect, useState } from "react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import {
  Box,
  Button,
  Grid,
  Paper,
  Typography,
  Card,
  CardContent,
  TextField,
  Grid2,
  IconButton,
  CircularProgress,
  Skeleton,
} from "@mui/material";
import { useDrag, useDrop } from "react-dnd";
import { CREATE_CUSTOM_THERAPY } from "../../utils/constants";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { CenteredBox } from "../../components/layouts/OneViewBox";
import { useDispatch } from "react-redux";
import { RightDataAction } from "../../store/actions/therapyAction";

const MaskingAudioUi = ({
  setRight,
  setInput,
  input,
  handleSoundSelection,
  handleStopAll,
  left,
  dataloading,
  SoundCard,
  right,
  customList,
  handleMerge,
  mergedAudio,
  loading,
}) => {
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch()
  const [buttonType, setButtonType] = useState(
    CREATE_CUSTOM_THERAPY.ENVIRONMENTAL
  );
  const [{ isOver }, drop] = useDrop({
    accept: "SOUND",
    drop: (item) => handleSoundSelection(item.sound),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  });

  const backButton = () => {
    if (right.length > 0) {
      handleStopAll();
    }
    dispatch(RightDataAction([]));
    navigate(`/Patient-Details/${params.id}`);
  };
  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <Box
          sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
        >
          <IconButton
            sx={{ marginRight: "10px" }}
            onClick={() => {
              backButton();
            }}
          >
            <ArrowBackIosNewIcon sx={{ color: "#424242" }} />
            <Typography
              ml={2}
              className="AxiformaRegular"
              sx={{ fontSize: "24px", alignItems: "center", color: "#424242" }}
            >
              Back
            </Typography>
          </IconButton>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <Typography
            className="AxiformaMedium"
            variant="h6"
            ml={2}
            sx={{
              fontSize: "24px",
              alignItems: "center",
              letterSpacing: "0.8em",
            }}
          >
            CUSTOM THERAPY
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",  
          height: "80vh",
          border: "1px solid #DEDEDE",
          backgroundColor: "white",
          borderRadius: "10px",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={7}>
            <Box ml={5} mr={5} mt={5}>
              <TextField
                value={input}
                onChange={(e) => {
                  setInput(e.target.value);
                }}
                variant="standard"
                sx={{ width: "100%" }}
                // rows={1.5}
                // multiline
                className="AxiformaSemiBold"
                InputLabelProps={{
                  sx: {
                    // fontFamily: "Axiforma",
                    // fontWeight: 600,
                    fontSize: "24px",
                    color: "#424242",
                  },
                }}
                inputProps={{
                  style: {
                    // fontFamily: "Axiforma",
                    fontSize: "24px",
                    // fontWeight: 600,
                    color: "#424242",
                  },
                }}
                onFocus={(event) => {
                  if (input === "Untitled therapy") {
                    event.target.select();
                  }
                }}
              />
            </Box>
            <Box
              mt={4}
              ml={5}
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: "20px",
                width: "50vw",
              }}
            >
              <Button
                variant={
                  buttonType === CREATE_CUSTOM_THERAPY.ENVIRONMENTAL
                    ? "contained"
                    : "outlined"
                }
                onClick={() =>
                  setButtonType(CREATE_CUSTOM_THERAPY.ENVIRONMENTAL)
                }
                sx={{
                  width: "10vw",
                  padding: 2,
                  color:
                    buttonType === CREATE_CUSTOM_THERAPY.ENVIRONMENTAL
                      ? "white"
                      : "#424242",
                  border:
                    buttonType === CREATE_CUSTOM_THERAPY.ENVIRONMENTAL
                      ? ""
                      : "1px solid #DEDEDE",
                }}
              >
                <Typography
                  className="AxiformaBold"
                  sx={{ fontSize: "14px", alignItems: "center" }}
                >
                  {" "}
                  Environmental
                </Typography>
              </Button>
              <Button
                variant={
                  buttonType === CREATE_CUSTOM_THERAPY.MUSIC
                    ? "contained"
                    : "outlined"
                }
                onClick={() => setButtonType(CREATE_CUSTOM_THERAPY.MUSIC)}
                sx={{
                  width: "10vw",
                  padding: 2,
                  color:
                    buttonType === CREATE_CUSTOM_THERAPY.MUSIC
                      ? "white"
                      : "#424242",
                  border:
                    buttonType === CREATE_CUSTOM_THERAPY.MUSIC
                      ? ""
                      : "1px solid #DEDEDE",
                }}
              >
                <Typography
                  className="AxiformaBold"
                  sx={{ fontSize: "14px", alignItems: "center" }}
                >
                  {" "}
                  Music
                </Typography>
              </Button>
              <Button
                variant={
                  buttonType === CREATE_CUSTOM_THERAPY.THERAPEUTIC
                    ? "contained"
                    : "outlined"
                }
                onClick={() => setButtonType(CREATE_CUSTOM_THERAPY.THERAPEUTIC)}
                sx={{
                  width: "10vw",
                  padding: 2,
                  color:
                    buttonType === CREATE_CUSTOM_THERAPY.THERAPEUTIC
                      ? "white"
                      : "#424242",
                  border:
                    buttonType === CREATE_CUSTOM_THERAPY.THERAPEUTIC
                      ? ""
                      : "1px solid #DEDEDE",
                }}
              >
                <Typography
                  className="AxiformaBold"
                  sx={{ fontSize: "14px", alignItems: "center" }}
                >
                  {" "}
                  Therapeutic
                </Typography>
              </Button>
            </Box>

            <Box
              mt={3}
              mb={3}
              sx={{
                border: "1px solid #DEDEDE",
                flexDirection: "column",
                width: "100% ",
              }}
            />
            {dataloading ? (
              <Box
                mt={4}
                mb={4}
                p={4}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  height: "5vh",
                  gap: "10px",
                }}
              >
                {[
                  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
                  18, 19, 20, 21, 22, 23, 24, 25, 26,27,28,29,30,31,32,
                ]?.map((row) => (
                  <Skeleton
                    key={row}
                    variant="rectangular"
                    width={"10%"}
                    height={100}
                    sx={{
                      borderRadius: "8px",
                      boxShadow:
                        "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                    }}
                  />
                ))}
              </Box>
            ) : (
              <Grid
                container
                spacing={2}
                sx={{
                  display: "flex",
                  maxHeight: "60vh",
                  overflow: "auto",
                  scrollbarWidth: "none",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  pl: 3,
                }}
              >
                {left
                  ?.filter((sound) => sound.category === buttonType)
                  ?.map((sound, index) => (
                    <Grid2
                      item
                      xs={2}
                      sm={2}
                      md={2}
                      sx={{
                        padding: 3,
                        height: "150px",
                        minHeight: "150px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                      key={index}
                    >
                      <SoundCard sound={sound} />
                    </Grid2>
                  ))}
              </Grid>
            )}
          </Grid>

          <Box
            mt={2}
            sx={{ borderRight: "1px solid #DEDEDE", height: "79.8vh" }}
          />

          <Grid item xs={4.5}>
            <Typography className="AxiformaMedium" variant="h6" ml={3} mt={3}>
              Selected Sounds
            </Typography>
            <Box
              ref={drop}
              my={4}
              sx={{
                // height: '100%'
                width: "39vw",
                background: isOver ? "#f0f0f0" : "transparent",
                maxHeight: "60vh",
                minHeight: "60vh",
                overflow: "auto",
                scrollbarWidth: "none",
              }}
            >
              {customList(right)}
            </Box>
            {right.length > 0 && (
              <Button
                onClick={handleMerge}
                disabled={loading}
                className="AxiformaRegular"
                variant="contained"
                sx={{
                  height: "8vh",
                  borderRadius: "10px",
                  ml: 1,
                  width: "39vw",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#424242",
                  color: "#FFFFFF",
                }}
              >
                <Typography
                  className="AxiformaBold"
                  sx={{ fontSize: "24px", alignItems: "center" }}
                >
                  {loading ? (
                    <CenteredBox>
                      <CircularProgress />
                    </CenteredBox>
                  ) : (
                    "Next"
                  )}{" "}
                </Typography>
              </Button>
            )}
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default MaskingAudioUi;
